import { render } from "./EditFactureS.vue?vue&type=template&id=5bf03828&ts=true"
import script from "./EditFactureS.vue?vue&type=script&lang=ts"
export * from "./EditFactureS.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__